if (!customElements.get('shipping-cutoff-message')) {
  class ShippingCutoffMessage extends HTMLElement {
    connectedCallback() {
      this.textElement = this.querySelector('.shipping-cutoff-message__text');
      this.cutoff = parseInt(this.getAttribute('cutoff'), 10) || 15;
      this.timezoneOffset = this.getAttribute('timezone-offset') || '+0000';
      this.messages = {
        orderWithinToday: this.dataset.orderWithinToday || '',
        shipTomorrow: this.dataset.shipTomorrow || '',
        shipMonday: this.dataset.shipMonday || '',
      };
      this.hoursPlaceholder = this.dataset.hoursPlaceholder || '___HOURS___';

      this.update();
      this.interval = window.setInterval(() => this.update(), 60000);
    }

    disconnectedCallback() {
      if (this.interval) {
        window.clearInterval(this.interval);
      }
    }

    update() {
      if (!this.textElement) return;
      this.textElement.innerHTML = this.formatBoldMarkup(this.getMessage());
    }

    formatBoldMarkup(text) {
      const escaped = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      return escaped.replace(/\*([^*]+)\*/g, '<strong>$1</strong>');
    }

    getStoreDate() {
      const match = this.timezoneOffset.match(/^([+-])(\d{2})(\d{2})$/);
      if (!match) return new Date();

      const sign = match[1] === '+' ? 1 : -1;
      const offsetHours = parseInt(match[2], 10);
      const offsetMinutes = parseInt(match[3], 10);
      const offsetMs = sign * (offsetHours * 60 + offsetMinutes) * 60 * 1000;
      const now = new Date();
      const utc = now.getTime() + now.getTimezoneOffset() * 60000;

      return new Date(utc + offsetMs);
    }

    getMessage() {
      const storeDate = this.getStoreDate();
      const hour = storeDate.getHours();
      const day = storeDate.getDay();

      if (day === 6) return this.messages.shipMonday;

      if (day >= 0 && day <= 4) {
        if (hour < this.cutoff) return this.formatHoursMessage(this.cutoff - hour);
        return this.messages.shipTomorrow;
      }

      if (day === 5) {
        if (hour < this.cutoff) return this.formatHoursMessage(this.cutoff - hour);
        return this.messages.shipMonday;
      }

      return this.messages.shipTomorrow;
    }

    formatHoursMessage(hoursLeft) {
      const safeHours = Math.max(hoursLeft, 1);
      return this.messages.orderWithinToday.replace(this.hoursPlaceholder, safeHours);
    }
  }

  customElements.define('shipping-cutoff-message', ShippingCutoffMessage);
}
